"use strict";

var _defineProperty = require("/home/circleci/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/defineProperty");

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

exports.__esModule = true;
exports.default = void 0;
var defaultLogo = {
  color: 'primary',
  width: '142px',
  height: '53px'
};
var navDefaults = {
  accentColor: 'accent2',
  backgroundColor: 'white',
  backdropColor: 'rgba(0, 0, 0, 0.15)',
  boxShadow: '0 0.2rem 1rem 0 rgba(0, 0, 0, 0.15);',
  borderColor: 'rgb(239, 239, 239)',
  height: '9.2rem',
  // TODO this to use theme font sizing
  linkLabelFontSize: '1.6rem',
  logo: defaultLogo,
  mobileBreakpoint: 'small'
};
var nav = {
  horizon: _objectSpread({}, navDefaults),
  cannesLions: _objectSpread({}, navDefaults),
  lionsLive: _objectSpread({}, navDefaults),
  money2020: _objectSpread({}, navDefaults),
  ascential: _objectSpread({}, navDefaults),
  dcl: _objectSpread({}, navDefaults),
  lionsCreativity: _objectSpread(_objectSpread({}, navDefaults), {}, {
    logo: _objectSpread(_objectSpread({}, defaultLogo), {}, {
      width: '171px',
      height: '48px'
    })
  })
};
var _default = nav;
exports.default = _default;